/* REDTEC v24 · Comparador de modelos (sections/redtec-comparador.liquid). Carregado com defer. */
(function () {
  function init(root) {
    if (root.__rtCmp) return;
    root.__rtCmp = true;
    var data;
    try { data = JSON.parse(root.querySelector('[data-rt-cmp-data]').textContent); } catch (e) { data = []; }
    var sym = root.getAttribute('data-sym') || '';
    data = data.filter(function (p) { return p.avail; });
    if (!data.length) { root.hidden = true; return; }
    data.sort(function (a, b) { return (a.ord - b.ord) || String(a.title).localeCompare(String(b.title), 'pt-BR'); });
    var byId = {};
    data.forEach(function (p) { byId[p.id] = p; });
    var cols = Array.prototype.slice.call(root.querySelectorAll('.rt-cmp__col'));
    var selects = cols.map(function (c) { return c.querySelector('[data-rt-cmp-select]'); });
    var table = root.querySelector('[data-rt-cmp-table]');
    var cur = root.getAttribute('data-current');
    var sel = [];
    var m = /[#&?]p=([^&]+)/.exec(location.hash || '');
    if (cur && byId[cur]) sel.push(String(cur));
    if (m) {
      var h = decodeURIComponent(m[1]);
      data.some(function (p) { if (p.handle === h && sel.indexOf(String(p.id)) < 0) { sel.push(String(p.id)); return true; } });
    }
    data.forEach(function (p) { if (sel.length < cols.length && sel.indexOf(String(p.id)) < 0) sel.push(String(p.id)); });

    selects.forEach(function (s, i) {
      var frag = document.createDocumentFragment();
      data.forEach(function (p) { var o = document.createElement('option'); o.value = p.id; o.textContent = p.title; o.title = p.full || p.title; frag.appendChild(o); });
      s.appendChild(frag);
      s.value = sel[i] || data[0].id;
      s.addEventListener('change', function () { sel[i] = s.value; render(); });
    });

    function esc(v) { return v == null || v === '' ? '—' : String(v); }
    function html(v) { return String(v).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function bool(v) {
      if (v === true || v === 'true' || v === 'Sim' || v === 'sim') return '<span class="rt-cmp__yes">✓ Sim</span>';
      if (v === false || v === 'false' || v === 'Não' || v === 'não' || v === 'Nao') return '<span class="rt-cmp__no">✕ Não</span>';
      return v == null || v === '' ? '—' : html(v);
    }
    function num(v) { if (v == null || v === '') return NaN; var n = parseFloat(String(v).replace(/[^\d,.-]/g, '').replace(',', '.')); return isNaN(n) ? NaN : n; }
    function fmtPeso(v) { var n = num(v); return isNaN(n) ? esc(v) : n.toFixed(2).replace('.', ',') + ' kg'; }
    function matCell(v) {
      if (v == null || v === '') return '—';
      return '<span class="rt-cmp__mat">' + html(v) + (sym ? '<img class="rt-cmp__sym" src="' + sym + '" alt="" width="16" height="16" loading="lazy" decoding="async">' : '') + '</span>';
    }
    var best = { cap: 'max', peso: 'min' };

    function render() {
      cols.forEach(function (c, i) {
        var p = byId[sel[i]] || data[0];
        var img = c.querySelector('[data-rt-cmp-img]');
        if (img.getAttribute('src') !== p.img) { img.src = p.img || ''; }
        img.alt = p.full || p.title;
        c.querySelectorAll('[data-rt-cmp-link]').forEach(function (a) { a.href = p.url; });
        var name = c.querySelector('[data-rt-cmp-name]'); name.textContent = p.title; name.title = p.full || p.title;
        c.querySelector('[data-rt-cmp-price]').textContent = p.price;
        c.querySelector('[data-rt-cmp-vid]').value = p.vid || '';
        var b = c.querySelector('[data-rt-cmp-buy]'); b.disabled = !p.avail || !p.vid; b.textContent = p.avail ? 'Comprar' : 'Indisponível';
        selects[i].value = p.id;
      });
      Array.prototype.forEach.call(table.querySelectorAll('tbody tr'), function (tr) {
        var key = tr.getAttribute('data-row'); var vals = [];
        cols.forEach(function (c, i) {
          var p = byId[sel[i]] || data[0]; var v = p[key]; var td = tr.querySelector('[data-cell="' + i + '"]');
          td.classList.remove('is-best');
          if (key === 'anac' || key === 'exp') td.innerHTML = bool(v);
          else if (key === 'peso') td.textContent = fmtPeso(v);
          else if (key === 'mat') td.innerHTML = matCell(v);
          else td.textContent = esc(v);
          vals.push(num(v));
        });
        if (best[key]) {
          var ok = vals.filter(function (n) { return !isNaN(n); });
          if (ok.length > 1 && Math.min.apply(null, ok) !== Math.max.apply(null, ok)) {
            var target = best[key] === 'max' ? Math.max.apply(null, ok) : Math.min.apply(null, ok);
            vals.forEach(function (n, i) { if (n === target) tr.querySelector('[data-cell="' + i + '"]').classList.add('is-best'); });
          }
        }
      });
      var cents = cols.map(function (c, i) { return (byId[sel[i]] || data[0]).cents; });
      var minC = Math.min.apply(null, cents), maxC = Math.max.apply(null, cents);
      cols.forEach(function (c, i) { c.querySelector('[data-rt-cmp-price]').classList.toggle('is-best', cents[i] === minC && minC !== maxC); });
    }
    render();
    window.addEventListener('hashchange', function () {
      var mm = /[#&?]p=([^&]+)/.exec(location.hash || ''); if (!mm) return;
      var hh = decodeURIComponent(mm[1]);
      data.some(function (p) { if (p.handle === hh) { if (sel.indexOf(String(p.id)) < 0) { sel[0] = String(p.id); render(); } return true; } });
    });
    document.querySelectorAll('[data-rt-compare-open]').forEach(function (btn) {
      btn.hidden = false;
      btn.addEventListener('click', function (e) { e.preventDefault(); root.scrollIntoView({ behavior: 'smooth', block: 'start' }); selects[0] && setTimeout(function () { selects[0].focus(); }, 600); });
    });
  }
  document.querySelectorAll('#rt-comparador[data-section-id]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('#rt-comparador'); if (r) init(r); });
})();
